import { Form, FormField, FormFieldConditions, FormSection, FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { InputType } from 'src/app/common/components/reactive-form-builder/interfaces/input.interface';
import { ClienteAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';


export class ClienteListModalFormDefinition {
  public readonly formFields: Form<ClienteAlbaranModel>;
  public readonly model: Partial<ClienteAlbaranModel>;

  constructor(type: FormType, model: Partial<ClienteAlbaranModel>, _context: unknown = {}) {
    this.model = model;
    this.formFields = {
      name: 'cliente-albaran-list-modal',
      header: 'Detalle del registro',
      type,
      sections: this.getSections(),
      table: null,
      uploadButton: { isEnabled: false, label: '' },
      signed: false,
    };
  }

  private getSections(): FormSection<ClienteAlbaranModel>[] {
    return [
      {
        name: '',
        fields: [
          this.textField('nombre', 'Nombre', 1, true, 4),
          this.textField('alias', 'Alias', 2, true, 4),
          this.textField('email', 'Email', 3, true, 4),
          this.textField('direccion', 'Dirección', 4, true, 4),
          this.textField('localidad', 'Localidad', 5, true, 4),
          this.textField('provincia', 'Provincia', 6, true, 4),
          this.textField('telefono', 'Teléfono', 7, true, 4),
          this.textField('fax', 'Fax', 8, true, 4),
        ],
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private textField(name: string, label: string, order: number, isVisible = true, width = 4, inputType: InputType = InputType.TEXT): FormField<ClienteAlbaranModel> {
    return {
      name,
      vinculatedFields: undefined,
      label,
      input: {
        type: inputType,
        isEditable: true,
        ...(inputType === InputType.TEXTAREA ? { textAreaConfiguration: { hasVoiceTranscription: false, canTakePhoto: false, photoField: undefined } } : {}),
      },
      width,
      conditions: this.conditions({ isVisible }),
      order,
    };
  }


  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }

}
